<template>

  <!-- <teleport to="#tab-nav-extra" defer>
    <v-tabs v-model="activeTab" color="var(--color-primary)" hide-slider density="compact">
      <v-tab value="table">
        <v-icon>mdi-table</v-icon>
      </v-tab>
      <v-tab value="chart">
        <v-icon>mdi-chart-line</v-icon>
      </v-tab>
    </v-tabs>
  </teleport> -->

  <v-tabs-window v-model="activeTab" v-bind="$attrs">
    <v-tabs-window-item value="table">
      <Table />
    </v-tabs-window-item>
    <v-tabs-window-item value="chart">
      <Chart />
    </v-tabs-window-item>
  </v-tabs-window>

</template>
<script setup>
import { ref, computed } from 'vue'
import Table from './Table.vue'
import Chart from './Chart.vue'
const activeTab = ref('table')

</script>
